import { createAction, props } from '@ngrx/store';

export const toggleFiltersOpen = createAction('[Portal] Toggle Filters Option');
